<nav *ngIf="authService.isLoggedIn()">
  <app-navbar></app-navbar>
</nav>
<app-loader></app-loader>
<router-outlet />
